// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bf4655f9","372":"75e972e4","498":"53b29ed4","598":"740829ab","703":"e5326429","738":"99ce7111","856":"19049f7f"}[chunkId] + ".chunk.js";
};